import { css } from '@emotion/react'
import type { ReactNode } from '@tanstack/react-router'
import { type HTMLMotionProps, motion } from 'motion/react'
import { type ReactElement, forwardRef } from 'react'

export interface ActionButtonProps extends HTMLMotionProps<'div'> {
	icon?: ReactElement
	children?: ReactNode
}

export default forwardRef<HTMLDivElement, ActionButtonProps>(function ActionButton(
	{ icon, children, ...props }: ActionButtonProps,
	ref
) {
	return (
		<motion.div
			ref={ref}
			whileTap={{ scale: 0.95 }}
			css={css`
				display: flex;
				align-items: center;
				gap: 4px;
				height: 36px;
				padding: 0 12px;
				border-radius: 9999px;
				user-select: none;
				cursor: pointer;
				font-variant-numeric: tabular-nums;
				transition: background-color 0.3s;

				&:hover {
					background-color: var(--bg-surface-body-1);
				}
			`}
			{...props}
			onClick={(e) => {
				e.stopPropagation()
				props.onClick?.(e)
			}}
		>
			{icon}
			{children}
		</motion.div>
	)
})
